import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=073f2bae&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "@/style/form.styl?vue&type=style&index=0&id=073f2bae&lang=stylus&scoped=true&"
import style1 from "./Result.vue?vue&type=style&index=1&id=073f2bae&lang=stylus&scoped=true&"
import style2 from "./Result.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073f2bae",
  null
  
)

export default component.exports